import { render } from "./App.vue?vue&type=template&id=18ca6f32"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=18ca6f32&lang=css"

import exportComponent from "D:\\vue\\不同模板项目\\template\\chengshineilao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__